export default {"src":"/_next/static/media/searchIcon.db5f2cb2.svg","height":17,"width":16};